/* Secure Funding America / loan-estimator.js (Prism)
   Informational estimator only. Not an offer or a prediction of approval. */
(function () {
  "use strict";

  var APR_LOW = 0.0749;
  var APR_HIGH = 0.2399;
  var BURST_HUES = ["#FF5A3C", "#6C5BD4", "#FFAF26", "#17B8A6"];

  var reduceMotion = false;
  if (window.matchMedia) {
    reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  function money(n) {
    return "$" + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function monthly(amount, months, apr) {
    var r = apr / 12;
    if (r === 0) return amount / months;
    var f = Math.pow(1 + r, months);
    return (amount * r * f) / (f - 1);
  }

  function burst(container) {
    if (reduceMotion || !container) return;
    for (var i = 0; i < 8; i++) {
      var p = document.createElement("i");
      p.className = "burst";
      p.style.background = BURST_HUES[i % BURST_HUES.length];
      p.style.left = (40 + Math.random() * 20) + "%";
      p.style.top = "48%";
      p.style.setProperty("--bx", (Math.random() * 140 - 70).toFixed(0) + "px");
      p.style.setProperty("--by", (-30 - Math.random() * 70).toFixed(0) + "px");
      container.appendChild(p);
      (function (el) {
        setTimeout(function () {
          if (el.parentNode) el.parentNode.removeChild(el);
        }, 800);
      })(p);
    }
  }

  ready(function () {
    var root = document.querySelector("[data-estimator]");
    if (!root) return;

    var amountInput = root.querySelector("[data-est-amount]");
    var termInput = root.querySelector("[data-est-term]");
    var purposeInput = root.querySelector("[data-est-purpose]");
    var amountLabel = root.querySelector("[data-est-amount-label]");
    var termLabel = root.querySelector("[data-est-term-label]");
    var result = root.querySelector("[data-est-result]");
    var resultBox = root.querySelector("[data-est-result-box]") || (result ? result.parentElement : null);
    if (!amountInput || !termInput || !result) return;

    var firstRun = true;

    function update() {
      var amount = parseInt(amountInput.value, 10);
      var months = parseInt(termInput.value, 10);

      if (amountLabel) amountLabel.textContent = money(amount);
      if (termLabel) termLabel.textContent = months + " months";

      var low = monthly(amount, months, APR_LOW);
      var high = monthly(amount, months, APR_HIGH);
      result.textContent = money(low) + " to " + money(high);

      /* Result pop re-trigger (forced reflow so it replays every input) */
      result.classList.remove("is-verified");
      void result.offsetWidth;
      result.classList.add("is-verified");

      if (!firstRun) burst(resultBox);
      firstRun = false;
    }

    amountInput.addEventListener("input", update);
    termInput.addEventListener("input", update);
    if (purposeInput) purposeInput.addEventListener("input", update);
    update();
  });
})();
